export const RAFFLE_PROGRAM_ID = process.env
	.REACT_APP_RAFFLE_PROGRAM_ID as string;
